<template>
  <layout name="LayoutDefault">
    <div class="About">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row ">
            <div class="col-lg-12 ">
              <div class="col-lg-2 ml-auto p-0">
                <select class="form-control" v-model="filterBy" v-on:change="change">
                  <option value="">Select Sort</option>
                  <option value="newest" :selected="filterBy === 'newest'">Newest First</option>
                  <option value="oldest" :selected="filterBy === 'oldest'">Oldest First</option>
                  <option value="az" :selected="filterBy === 'az'">A-Z</option>
                  <option value="za" :selected="filterBy === 'za'">Z-A</option>
                </select>
              </div>

              <div class="section-items ">
                <div v-if="loader">
                  <img slot="preloader" v-bind:src="`${IMAGEURL}/assets/img/loader.gif`" title="Loading..." />
                </div>
                <div class="row">
                  <div v-for="(item, k) in items" :key="k" class="col-lg-2 col-sm-6 col-6">
                    <BookCard
                      :item="item"
                      @add-to-cart="addToCart"
                    />
                  </div>
                </div>
              </div>

              <nav class="d-flex justify-content-center">
                <ul class="pagination">
                  <li v-for="(item, k) in links" :key="k" :class="getPagingClass(item)">
                    <a class="page-link" @click="getProducts(item.url)" href="javascript:;" v-html="getPagingLabel(item)"></a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";
import Pagination from "vue-and-pagination";
import BookCard from "../components/BookCard.vue";

export default {
  name: `Category`,
  data() {
    return {
      loader: true,
      links: null,
      filterBy: this.$route.query.sort ? this.$route.query.sort : '',
      breadType: "",
      items: "",
      orderBy: "",
    };
  },
  components: {
    Layout,
    "vue-load-image": VueLoadImage,
    Pagination,
    BookCard
  },
  methods: {
    change() {
      let url = this.$helper.UrlGenerate('sort', this.filterBy);
      window.location.href = url;
    },
    getPagingLabel(item) {
      let string = item.label;
      string = string.replace("Next", "");
      string = string.replace("Previous", "");
      return string;
    },
    getPagingClass(item) {
      if (item.url && item.active === true) {
        return "page-item active";
      } else if (!item.url) {
        return "page-item disabled";
      } else {
        return "page-item";
      }
    },
    getProducts(url, sortBy) {
      fetch(url)
        .then(response => response.json())
        .then(json => {
          this.items = json.data;
          this.loader = false;
          console.log(json);
          this.links = json.links;
          $(".back-to-top").trigger("click");
        });
    },
    addToCart(row) {
      let itemObj = {
        session_id: localStorage.getItem("session_id"),
        product_id: row.id,
        image: row.image,
        price: row.price,
        quantity: 1,
        name: row.product_name
      };
      this.$helper.saveToCart(itemObj);
      var cartCount = this.$helper.cartCount();
      $(".cart-count").text(cartCount);
      this.flashMessage.success({ message: "Added item to cart" });
    }
  },
  mounted() {
    console.log(this.$route.params.id);
    let url = this.APIURL + "home-sections/" + this.$route.params.id + '?sort=' + this.filterBy;
    this.getProducts(url, this.filterBy);
  }
};
</script>
